var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center py-5"},[_c('b-col',{attrs:{"md":"12","sm":"12"}},[_c('register-form',{attrs:{"custom_error":_vm.error},on:{"onUserCreated":_vm.markCreated,"onUserConfirmed":_vm.markConfirmed}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }